import { EOSService } from "../../api/eos-service";
import { GeoLocationService } from "../../api/geolocation-service";

const initialState = () => {
    return {

    }
}
const state = initialState()

const getters = {};

const actions = {
    async GetGeoLocation() {
        return await EOSService.makeRequest(GeoLocationService.GetGeoLocation())
    },
    async AddGeoLocation(context, { data }) {
        var _data = {
            Name:data.name,
            Latitude: data.lat,
            Longtitude: data.lng,
            radius: data.radius,
            personnelList:data.personnelList,
            sectionList:data.sectionList
        }
        return await EOSService.makeRequest(GeoLocationService.AddGeoLocation(_data))
    },
    async GetGeoLocationAllowedPersonels(context, { params }) {
        var _params = {
            id: params.id,
        }
        return await EOSService.makeRequest(GeoLocationService.GetGeoLocationAllowedPersonels(_params))
    },
    async GetGeoLocationAllowedSections(context, { params }) {
        var _params = {
            id: params.id,
        }
        return await EOSService.makeRequest(GeoLocationService.GetGeoLocationAllowedSections(_params))
    },
    async ModifyGeoLocation(context, { data }) {
        var _data = {
            id: data.id,
            Name:data.name,
            Latitude: data.lat,
            Longtitude: data.lng,
            radius: data.radius,
            personnelList:data.personnelList,
            sectionList:data.sectionList
        }
        return await EOSService.makeRequest(GeoLocationService.ModifyGeoLocation(_data))
    },
    async DeleteGeoLocation(context, { params }) {
        var _params = {
            id: params.id,
        }
        return await EOSService.makeRequest(GeoLocationService.DeleteGeoLocation(_params))
    },
    async isValidLocation(context, { data }) {
        var _data = {
            Longtitude: data.Longtitude,
            Latitude: data.Latitude,
            PersonnelList:data.PersonnelList,
            SectionList:data.SectionList,
            Perno:data.Perno,
            Section:data.Section
        }
        return await EOSService.makeRequest(GeoLocationService.isValidLocation(_data))
    },
    async GetIoPageLocation(context, { params }) {
        var _params = {
            pageNo: params.pageNo,
        }
        return await EOSService.makeRequest(GeoLocationService.GetIoPageLocation(_params))
    },
    async AddIoWithLocation(context, { data }) {
        if (!data.Perno) {
            var perno = context.rootState.auth.auth.username;
            data.Perno = perno;
        }

        var _data = {
            Perno: data.Perno,
            InDate: data.InDate,
            InTime: data.InTime,
            ClockValue: data.ClockValue,
            Description: data.Description,
            IoKind: data.IoKind,
            Id: data.Id,
            lon: data.lon,
            lat: data.lat,
            image:data.Image,
        }
        return await EOSService.makeRequest(GeoLocationService.AddIoWithLocation(_data))
    },
   
};

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}